import React from 'react';
import { ItemComponent } from './default-item';
/**
 * the default header style component
 * when the renderHeader props was omitted, this default style will be used
 * @param {string} header - header text
 * @returns {Object} will return the mapping react component
 */
export const renderHeader = header => (
  <div className="panel-heading">
    <h4 className="panel-title">
      {header}
    </h4>
  </div>
);

/**
 * the default empty style component
 * when the renderEmptyList props was omitted, this default style will be used
 * @param {string} emptyTips - empty text
 * @returns {Object} will return the mapping react component
 */
export const renderEmptyList = emptyTips => (
  <div className="empty-content">
    {emptyTips}
  </div>
);

/**
 * the default item style component
 * when the renderItem props was omitted, this default style will be used
 * @param {string} item - item info
 * @param {number} index - item index
 * @returns {Object} will return the mapping react component
 */
export const renderItem = (item, index) => (<ItemComponent item={item} index={index} />);
